import { useEffect, useState } from 'react';
import errorHandler from 'src/utils/error-handler';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';
import Avatar from 'src/componentes/avatar';
import ReactQuillValueRender from 'src/componentes/ReactQuillValueRender';
import moment from 'moment';

function Historico({ projetoId, etapaStageGateId }) {
  const intl = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [historico, setHistorico] = useState([]);
  const { user } = useAuth();
  const locale = user && user.idioma ? user.idioma : 'en-us';

  const getHistorical = async () => {
    try {
      setIsLoading(true);
      const response = await http.post(
        '/StageGate/ObterHistoricoEtapaStageGate',
        {
          projetoId: projetoId,
          etapaStageGateId: etapaStageGateId,
        }
      );
      if (response.data) {
        setHistorico(response.data);
      }
    } catch (err) {
      errorHandler(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHistorical();
  }, []);

  return (
    <div
      className={`overflow-auto new-list-tree${
        isLoading ? ' isLoading-ref' : ''
      }`}
      style={{ maxHeight: 'calc(100vh - 83px)', width: '100%' }}
    >
      <div className="bg-white px-3 py-4 mt-3 border-light-gray rounded-lg">
        <div className="d-flex flex-column w-100">
          {historico && historico.length > 0 ? (
            historico.map((alteracao, index) => (
              <div key={index} className="mb-3 w-100">
                <div className="d-flex mb-3">
                  <Avatar
                    foto={alteracao.colaborador?.fotoArquivo}
                    showLabel={false}
                    border={0}
                    size={45}
                    label={alteracao.colaborador?.nome}
                  />
                  <div className="ml-3 mt-1">
                    <div className="text-lg font-weight-bolder">
                      {alteracao.colaborador?.nome}
                    </div>
                    <div className="d-flex">
                      {`${intl.formatMessage({ id: 'em' })} ${moment(
                        alteracao.data
                      )
                        .locale(locale)
                        .format('L')} ${intl.formatMessage({
                        id: 'às',
                      })} ${moment(alteracao.data)
                        .locale(locale)
                        .format('LT')}`}
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'justify' }}>
                  <ReactQuillValueRender value={alteracao.descricaoAlteracao} />
                </div>
                <hr
                  className="w-100"
                  style={{ borderTop: '2px solid #DDE6E9' }}
                />
              </div>
            ))
          ) : (
            <div className="d-flex flex-column align-items-center">
              <div>
                {intl.formatMessage({
                  id: 'label.nenhumRegistroEncontrado',
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const View = ({ projetoId, etapaStageGateId }) => (
  <Historico projetoId={projetoId} etapaStageGateId={etapaStageGateId} />
);

export default View;
